import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "bikeRack"
const BikeRackIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M19.125 3.75C19.125 4.552 18.496 5.204 17.705 5.246Q17.665 5.249 17.625 5.25H15.623L17.483 11.655Q17.738 11.625 18 11.625C20.485 11.625 22.5 13.64 22.5 16.125S20.485 20.625 18 20.625 13.5 18.61 13.5 16.125C13.5 14.341 14.538 12.8 16.042 12.072L15.788 11.196 10.2 14.508C10.393 15.01 10.5 15.555 10.5 16.125 10.5 18.61 8.485 20.625 6 20.625S1.5 18.61 1.5 16.125 3.515 11.625 6 11.625C7.377 11.625 8.608 12.244 9.434 13.218L10.204 12.76 7.8 8.25H6.375C5.961 8.25 5.625 7.914 5.625 7.5S5.961 6.75 6.375 6.75H10.5C10.914 6.75 11.25 7.086 11.25 7.5S10.914 8.25 10.5 8.25H9.5L11.498 11.994 15.356 9.708 13.626 3.75zM6 13.125C4.343 13.125 3 14.468 3 16.125S4.343 19.125 6 19.125 9 17.782 9 16.125C9 15.835 8.957 15.555 8.88 15.289L6.383 16.77C6.026 16.981 5.566 16.864 5.355 16.507 5.144 16.151 5.26 15.691 5.618 15.48L8.116 13.999C7.573 13.459 6.826 13.125 6 13.125M17.91 13.127 18.72 15.915C18.835 16.314 18.607 16.73 18.21 16.846 17.812 16.96 17.396 16.732 17.28 16.335L16.47 13.543C15.59 14.067 15 15.027 15 16.125 15 17.782 16.343 19.125 18 19.125S21 17.782 21 16.125 19.657 13.125 18 13.125Q17.955 13.125 17.91 13.127"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default BikeRackIcon
